// src/utils/imageMap.js
import selection_s1 from "../assets/quiz/selection-step1.png";
import insertion_s1 from "../assets/quiz/insertion-step1.png"; // นำเข้ารูปของ insertion
import bubble_s1 from "../assets/quiz/bubble-step1.png";
import heap_s1 from "../assets/quiz/heap-step1.png";
import q_s1 from "../assets/quiz/quick-step1.png";
import merge_s1 from "../assets/quiz/merge-step1.png";
import merge_s2 from "../assets/quiz/merge-step2.png";

export const quizImages = {
  "select_s1": selection_s1,
  "insert_s1": insertion_s1, 
  "bubble_s1": bubble_s1,
  "heap_s1": heap_s1,
  "q_s1": q_s1,
  "merge_s1": merge_s1,
  "merge_s2": merge_s2,
};